import { SERVICE_PROVIDERS } from 'modules/graphql/types';

/**
 * "Sending Platform" is a UI/UX specific term, which reflects the groupings
 * used on the frontend. Each "Sending Platform" has its own tile in the
 * Index page, and its own Details page.
 *
 * Each Sending Platform maps to one or more Service Providers. It is also
 * possible for one Service Provider to map to multiple Sending Platforms
 * (ie. CustomMTA, which can be used for both Custom Email and Custom Push).
 *
 * These constants are cased differently from the SERVICE_PROVIDERS enum
 * (kebab-case rather than TitleCase), to differentiate them more clearly.
 */
export const ITERABLE = 'iterable';
export const ITERABLE_SMS = 'iterableSms';
export const DYN = 'dyn';
export const SENDGRID = 'sendgrid';
export const MAILGUN = 'mailgun';
export const SPARKPOST = 'sparkpost';
export const TELNYX = 'telnyx';
export const TWILIO = 'twilio';
export const CUSTOM_EMAIL = 'customEmail';
export const CUSTOM_PUSH = 'customPush';
export const WHATS_APP = 'infobip';
export const SENDING_PLATFORMS = [
  ITERABLE,
  ITERABLE_SMS,
  DYN,
  SENDGRID,
  MAILGUN,
  SPARKPOST,
  TELNYX,
  TWILIO,
  CUSTOM_EMAIL,
  CUSTOM_PUSH,
  WHATS_APP,
] as const; // "as const" is necessary for type SendingPlatform below to correctly infer type

export type SendingPlatform = (typeof SENDING_PLATFORMS)[number];

export type ConfigurableSendingPlatforms = Exclude<
  SendingPlatform,
  typeof ITERABLE | typeof CUSTOM_PUSH
>;

export const EMAIL_SENDING_PLATFORMS = [MAILGUN, DYN, SENDGRID, SPARKPOST, CUSTOM_EMAIL];
export const SMS_SENDING_PLATFORMS = [ITERABLE_SMS, TWILIO, TELNYX];
export const THIRD_PARTY_SMS_SENDING_PLATFORMS = [TWILIO, TELNYX];

export const ServiceProvidersBySendingPlatform = {
  [ITERABLE]: [SERVICE_PROVIDERS.ITERABLE],
  [ITERABLE_SMS]: [SERVICE_PROVIDERS.TWILIO, SERVICE_PROVIDERS.TELNYX],
  [DYN]: [SERVICE_PROVIDERS.DYN],
  [SENDGRID]: [SERVICE_PROVIDERS.SENDGRID],
  [SPARKPOST]: [
    SERVICE_PROVIDERS.SPARKPOST,
    SERVICE_PROVIDERS.SPARKPOST_EU,
    SERVICE_PROVIDERS.SPARKPOST_ELITE,
  ],
  [MAILGUN]: [SERVICE_PROVIDERS.MAILGUN, SERVICE_PROVIDERS.MAILGUN_EU],
  [TWILIO]: [SERVICE_PROVIDERS.TWILIO],
  [TELNYX]: [SERVICE_PROVIDERS.TELNYX],
  [CUSTOM_EMAIL]: [SERVICE_PROVIDERS.CUSTOM_MTA],
  [CUSTOM_PUSH]: [SERVICE_PROVIDERS.CUSTOM_MTA],
  [WHATS_APP]: [SERVICE_PROVIDERS.INFOBIP],
};
